import { createSelector } from "@reduxjs/toolkit";
import { initialState } from "./slice";
import { reduceArr } from "@utils/helpers";

const selectDomain = (state) => state.schemeDetails || initialState;

export const makeSelectQuery = createSelector(
  selectDomain,
  (state) => state.query
);

export const makeSelectVariantTest = createSelector(
  selectDomain,
  (state) => state.variantTest
);

export const makeSelectOne = createSelector(selectDomain, (state) => state.one);

export const makeSelectIsAvailableVariant = createSelector(
  selectDomain,
  (state) => state.is_available_to_buy
);

export const makeSelectOfficeOptions = createSelector(
  selectDomain,
  (state) => state.officeOptions
);

export const makeSelectOfficeOptionsNorm = createSelector(
  makeSelectOfficeOptions,
  (substate) => reduceArr(substate)
);
